import styles from './S01.module.css'
import Button from '../Button/Button';
import Video from '../Video/Video';
import mainImg from './images/01-illustration.png'
import videoImg from './images/01-video.jpg'

export default function S01(){

  return <div className={styles.main}>
    <div className={styles.upper}>
      <img src={mainImg} alt="" />
      <Button href={process.env.PUBLIC_URL + "/GCDE_infographic.pdf"} text="See full infographic"/>
      <div className={styles.info}>
        <h3>The Global Commission’s final report Democracy and Emergencies:</h3>
        <p className={styles.text}>Lessons from COVID-19 for Democratic Resilience lays out 20 recommendations for more effective and democratic responses to current and future emergencies</p>
        <Button href="https://www.clubmadrid.org/wp-content/uploads/2021/12/Global-Commission_Report_DIGITAL.pdf" text="Read the Global Commission’s full report"/>

      </div>
    </div>
    <div className={styles.bottom}>
      <div className={styles.videoContainer}>
        <Video href="https://youtu.be/xI9LUgmJi48" bg={videoImg} btnColor="var(--light-blue)"/>
      </div>
      <div className={styles.info}>
        <h4>Why Club de Madrid convened a Global Commission on Democracy and Emergencies</h4>
        <p>COVID-19 hit democracies at a time of crisis – a crisis of truth and trust, a crisis of representation, populism, polarization. It galvanized those trends and brought weaknesses of democratic institutions, administrations and leadership in the spotlight. Tensions between individual rights and public health, and between democratic checks and balances and the imperative for quick action, posed challenges in all democracies.
<br/><br/>Yet COVID-19 has also brought signals of hope for democracy, and a rapid wave of democratic innovation. As we continue to fight COVID-19, our collective experience of the pandemic offers a series of lessons to strengthen the resilience of democracy to this and future emergencies.
</p>
      </div>
    </div>

  </div>;
}
